import { render, staticRenderFns } from "./back-stockreturnorder.vue?vue&type=template&id=df72c180&"
import script from "./back-stockreturnorder.vue?vue&type=script&lang=ts&"
export * from "./back-stockreturnorder.vue?vue&type=script&lang=ts&"
import style0 from "./back-stockreturnorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports